import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [token, setToken] = useState("");

  const onLogout = () => {
    localStorage.clear();
    setUser({});
    navigate("/");
  };

  const authInfo = {
    user,
    setUser,
    token,
    setToken,
    onLogout,
  };

  return authInfo;
};

export default useAuth;
